export default __webpack_public_path__ + "static/media/team95.7656cd75.JPG";